import React, { useEffect, useState } from "react";
import Loading from "./Loading";

const ConsoleLogs = () => {
  const [logs, setLogs] = useState([]);
  const [progress, setProgress] = useState(0);
  const [lastLog, setLastLog] = useState("");

  // Define progress milestones based on specific logs
  const progressMilestones = {
    "Received request to process PDF": 10,
    "PDF downloaded and saved": 20,
    "Starting file conversion to SVG format": 30,
    "Conversion started successfully": 40,
    "File uploaded successfully": 50,
    "Conversion finished successfully": 60,
    "Downloading converted SVG file": 70,
    "Text extraction from PDF completed": 80,
    "Shape count completed": 90,
    "All pages processed successfully": 100,
  };

  useEffect(() => {
    // const ws = new WebSocket("wss://ai-takeoff-ttf-production.up.railway.app/ws/logs");
    const ws = new WebSocket("wss://localhost:8000/ws/logs");

    ws.onmessage = (event) => {
      const newLog = event.data;
      setLogs((prevLogs) => [...prevLogs, newLog]);
      setLastLog(newLog);
      updateProgress(newLog);
    };

    ws.onerror = (error) => {
      console.error("WebSocket Error:", error);
    };

    return () => {
      ws.close();
    };
  }, []);

  const updateProgress = (logMessage) => {
    for (const [key, value] of Object.entries(progressMilestones)) {
      if (logMessage.includes(key)) {
        setProgress(value);
        break;
      }
    }
  };

  // ✅ Add `return` statement for the component
  return (
    lastLog ? (
      <div className="w-full max-w-[970px] mx-auto mt p-[20px] rounded-lg border border-gray-700 shadow-lg">
        {/* Last log message display */}
        <div className="flex justify-between items-center mb-4">
          <p className="text-gray-400 text-left">
            {lastLog || "Waiting for logs..."}
          </p>
          <p className="text-gray-400">{progress}%</p>
        </div>

        {/* Progress Bar */}
        <div className="w-full bg-gray-700 rounded-full h-2">
          <div
            className="bg-primary h-2 rounded-full transition-all duration-300"
            style={{ width: `${progress}%` }}
          ></div>
        </div>
      </div>
    ) : (
     <></>
    )
  );
};

export default ConsoleLogs;
